const BASE = process.env.REACT_APP_API_URL || '';

async function handleResponse(r) {
  if (!r.ok) {
    const text = await r.text();
    try {
      const data = JSON.parse(text);
      throw data;
    } catch (e) {
      if (e.name === 'SyntaxError') {
        throw { error: "Server Error: " + text.replace(/<[^>]+>/g, '').slice(0, 150) };
      }
      throw e;
    }
  }
  return await r.json();
}

const defaultOptions = {
  credentials: 'include',
  cache: 'no-store',
};

export const api = {
  get: (path) => fetch(`${BASE}${path}`, { ...defaultOptions }).then(handleResponse),
  post: (path, body) => fetch(`${BASE}${path}`, {
    ...defaultOptions,
    method: 'POST', 
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).then(handleResponse),
  put: (path, body) => fetch(`${BASE}${path}`, {
    ...defaultOptions,
    method: 'PUT', 
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).then(handleResponse),
  delete: (path) => fetch(`${BASE}${path}`, { 
    ...defaultOptions,
    method: 'DELETE' 
  }).then(handleResponse),
  upload: (path, formData) => fetch(`${BASE}${path}`, { 
    ...defaultOptions,
    method: 'POST', 
    body: formData 
  }).then(handleResponse),
};

export const SOCKET_URL = BASE;
export const API_BASE = BASE;
